import "./styles.css";

import Typography from "@mui/material/Typography";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/pro-solid-svg-icons";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";
import { sxOption } from "./sxProps";
import VoltarButton from "../../../components/Accessibility/VoltarButton";
import PageTitle from "../../../components/Accessibility/PageTitle";

export default function PalestrasEventos() {
  const navigate = useNavigate();
  const location = useLocation();
  const accessibility = useAccessibility();
  const [searchParams] = useSearchParams();
  const back = searchParams.get("back");

  const handleNavigate = (path: string) => {
    navigate(`${location.pathname}/${path}`);
  };

  const cardConstrastStyle = {
    ...accessibility.contrastStyle,
    ...accessibility.contrastBorderAccessibility,
  };
  return (
    <div className="palestras-eventos-content">
      <PageTitle text="Palestras e eventos" />
      <div
        style={cardConstrastStyle}
        className="palestras-eventos-option"
        tabIndex={0}
        onClick={() => handleNavigate("confirmados")}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            handleNavigate("confirmados");
          }
        }}
      >
        <Typography style={accessibility.textStyleAccessibility} sx={sxOption}>
          Confirmados
        </Typography>
        <FontAwesomeIcon icon={faChevronRight} />
      </div>
      <div
        style={cardConstrastStyle}
        className="palestras-eventos-option"
        tabIndex={0}
        onClick={() => handleNavigate("convites")}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            handleNavigate("convites");
          }
        }}
      >
        <Typography style={accessibility.textStyleAccessibility} sx={sxOption}>
          Convites
        </Typography>
        <FontAwesomeIcon icon={faChevronRight} />
      </div>
      {back === "s" && <VoltarButton onClick={() => navigate(-1)} />}
    </div>
  );
}
